module.exports = __webpack_public_path__ + "static/BG-d07ebf4d7cc39afde16a785ec0876fa9.jpg";